import React from 'react';

const JS_Location = () => {
  return (
    <div >
      <h1>JS_Location</h1>
      <p>Placeholder component for: "JS Location"</p>
    </div>
  );
};

export default JS_Location;
